import React, { Component } from 'react';
import { isEmpty, size } from "lodash";
import { 
    IconButton,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableFooter,
    TablePagination,
    Button,
    Box,
} from '@mui/material';
import Pagination from '../../../container/MUI/Pagination';
import CreditForm from './CreditForm';
import DebitForm from './DebitForm';
import { AddCircle, Refresh, DeleteRounded, ArrowBackIosRounded, ArrowBackRounded, Restore, AssignmentReturn, AssignmentReturned, KeyboardReturnOutlined, EditRounded } from '@mui/icons-material';
import CreditDetails from './CreditDetails';
import DeleteDialog from '../../common/DeleteDialog';
import Currency from '../../common/Currency';
import { SearchBarV2 } from '../../common/SearchBar';

class DebitsList extends Component {
    state = { 
        page: 0,
        rowsPerPage: 15,
        openDetails: false,
        openForm: false,
        openUpdate: false,
        openDetails: false,
        credit: {},
        debit: false,
        searchCredit: "",
    }

    handleChange = (e) => {
        this.setState({ searchCredit: e.target.value });
    };
    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ page: 0, rowsPerPage: parseInt(event.target.value) });
    };

    componentWillMount() {
        window.scrollTo(0, 0);
    }

    getFilteredList = () => {
        const { USERS, DEBITS } = this.props;
        const { searchCredit } = this.state;
        let list = Object.values(DEBITS)
        // users
        console.log('====================================');
        console.log({searchCredit});
        console.log('====================================');
        if(!isEmpty(searchCredit)){
            list = list.filter( item => (
                item.credit_ref.toLowerCase().includes(searchCredit.toLowerCase()) ||
                USERS[item.credit_user_id].username.toLowerCase().includes(searchCredit.toLowerCase()) ||
                USERS[item.credit_user_id].email.toLowerCase().includes(searchCredit.toLowerCase()) ||
                USERS[item.credit_user_id].lastname.toLowerCase().includes(searchCredit.toLowerCase())
            ))
        }
        return list
    }

    displayList = () => {
        const { DEBITS } = this.props;
        let tab = []
        let rows = 0
        if (!isEmpty(DEBITS)){
            let all = this.getFilteredList()            
            rows = size(all)
            console.log('====================================');
            console.log({all, rows});
            console.log('====================================');
            tab.push(this.getCreditList(all))
        }
        return {tab, rows}
    }


    getCreditList = (list) => {
        const { DEBITS, USERS, BANKS } = this.props
        const { rowsPerPage, page } = this.state;

        if (!isEmpty(DEBITS) && !isEmpty(USERS) && !isEmpty(BANKS) ){
            return list.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(item => {
                // let background = item.credit_op === "DEBIT" ? "#e48a88b3" : "light-blue"
                return (
                    <TableRow hover key={item.credit_id} className="clickable"
                           
                        title="Voir le Détail"
                    >
                        {/* <th scope="row">{item.user}</th> */}
                        <TableCell onClick={() => this.setState({ openDetails: true, credit: item })} >
                            {new Date(item.credit_creation_date).toLocaleString('fr-FR')}
                        </TableCell>
                        <TableCell onClick={() => this.setState({ openDetails: true, credit: item })} >
                            {item.credit_ref}
                        </TableCell>
                        <TableCell onClick={() => this.setState({ openDetails: true, credit: item })} >
                            <Currency value={item.credit_amount} />
                        </TableCell>
                        {/* <TableCell onClick={() => this.setState({ openDetails: true, credit: item })} >
                            {item.credit_total_available}
                        </TableCell> */}
                        <TableCell onClick={() => this.setState({ openDetails: true, credit: item })} >
                            {item.credit_user_id && USERS[item.credit_user_id].username} {item.credit_user_id && USERS[item.credit_user_id].lastname}
                        </TableCell>
                        <TableCell onClick={() => this.setState({ openDetails: true, credit: item })} >
                            {item.credit_user_id && USERS[item.credit_user_id].email}
                        </TableCell>
                        <TableCell onClick={() => this.setState({ openDetails: true, credit: item })} >
                            {item.credit_op}
                        </TableCell>
                        <TableCell onClick={() => this.setState({ openDetails: true, credit: item })} >
                            {item.credit_bank && BANKS[item.credit_bank].bank_name}
                        </TableCell>
                        
                        <TableCell>
                            <IconButton 
                                size="small" 
                                color="secondary"
                                onClick={ () => this.setState({openUpdate: true, selected: item}) }
                            >
                                <EditRounded />
                            </IconButton> 
                        </TableCell>      
                        <TableCell>
                            <IconButton 
                                size="small" 
                                color="secondary"
                                onClick={ () => this.setState({openDelete: true, selected: item}) }
                            >
                                <DeleteRounded />
                            </IconButton> 
                        </TableCell>      
                    </TableRow>
                )
            })
        }
    }

    handleClose = () => {
		this.setState({ 
            openDetails: false,
            openDelete: false,
            openUpdate: false,
            credit: {},
            selected: {},
            openForm: false,
            debit: false,
        });
    };    

    handleDelete = async () => {
        const { selected } = this.state;
        await this.props.deleteDebit(selected)
        if(this.props.STATE.credits.error){
            this.props.notif("error", this.props.STATE.credits.error)
        } else {
            this.props.notif("success", "Avance supprimée")
            this.setState({
                openDelete: false,
                selected: {},
            })
        }
    }
        
    render() {
        const { rowsPerPage, page, openDetails, credit, openDelete, openUpdate, selected } = this.state;
        console.log('==== STATE CREDIT LIST ================================');
        console.log(this.state);
        console.log('====================================');
        let data = this.displayList()
        return (
            <div>
                {openDetails && !isEmpty(credit) && 
                    <CreditDetails open={openDetails} handleClose={this.handleClose} {...this.props} credit={credit} />
                }
                {openUpdate && !isEmpty(selected) && 
                    <DebitForm handleClose={this.handleClose} {...this.props} debit={selected} update />
                }
                {openDelete && !isEmpty(selected) &&
                    <DeleteDialog
                        title={"l'avance"}
                        close={this.handleClose}
                        notif={this.props.notif}
                        handleSubmit={this.handleDelete}
                        disabledSubmit={this.props.STATE.debits.fetching}
                    >
                        Retour du {new Date(selected.credit_creation_date).toLocaleDateString("fr-FR")} - Montant: <Currency value={selected.credit_amount} />
                    </DeleteDialog>
                }

                <SearchBarV2
                    handleChange={this.handleChange} 
                    label="Rechercher"
                    searchValue={this.state.searchCredit}
                >
                    {/* <Box style={{ display: 'flex'}}>
                        <Button variant="contained" color="secondary" 
                            onClick={() => this.setState({ openForm: true })} 
                            title="Nouvelle Avance"
                        >
                            <AddCircle />
                            Créer
                        </Button>
                        {this.props.isSuper &&
                            <IconButton color="primary" onClick={this.props.recalcCredits}>
                                <Refresh />
                            </IconButton>
                        }
                    </Box> */}
                </SearchBarV2>  
                {!isEmpty(data.tab) && 
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Créé le</TableCell>
                                    <TableCell>Réference</TableCell>
                                    <TableCell>Montant</TableCell>
                                    {/* <TableCell>Restant</TableCell> */}
                                    <TableCell>User</TableCell>
                                    <TableCell>Email</TableCell>
                                    <TableCell>Type</TableCell>
                                    <TableCell>Banque</TableCell>
                                    <TableCell colSpan={2}>Options</TableCell> 
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data.tab}
                            </TableBody>
                            <TableFooter>
                                <TableRow>
                                    <TablePagination
                                        rowsPerPageOptions={[10, 15]}
                                        labelRowsPerPage="Lignes par Page"
                                        colSpan={10}
                                        count={data.rows}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        SelectProps={{
                                            native: true,
                                        }}
                                        onPageChange={this.handleChangePage}
                                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                                        ActionsComponent={Pagination}
                                    />
                                </TableRow>
                            </TableFooter>
                        </Table> 
                }
            </div>
        );
    }
}

export default DebitsList;